import axiosInstance from "../../axios/axiosInstance";
import { CATEGORY_LISTING, CREATE_CATEGORY, DELETE_CATEGORY, EDIT_CATEGORY, OFFER_LISTING, STATUS_UPDATE_CATEGORY } from "../../constants";

export const createCategory = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_CATEGORY, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getCategoryListing = () => onResponse => {
    try {
        axiosInstance.get(CATEGORY_LISTING)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};



export const getCategoryListingPaginate = (props) => onResponse => {
    const page = props?.page ? props?.page : ""
    const limit = props?.limit ? props?.limit : ""
    let BASE_URL = CATEGORY_LISTING + '?page=' + page + '&pageSize=' + limit
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const statusUpdateCategory = (id) => onResponse => {

    try {
        axiosInstance.delete(STATUS_UPDATE_CATEGORY + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const deleteCategory = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_CATEGORY + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const editCategory = (props) => onResponse => {

    try {
        axiosInstance.post(EDIT_CATEGORY, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};